export const formatNumberInput = (value) =>
  value &&
  value
    .toString()
    .replace(/(?!^)-/g, '')
    .replace(/[^-0-9.]/g, '')
    .replace(/(\..*)\./g, '$1');

export const formatMoney = (amount, forcePositive = false) =>
  (forcePositive ? Math.abs(parseFloat(amount)) : parseFloat(amount)).toFixed(2);

export const maxMoney = 9999999.99;

export const validateMaxMoney = (money) => (money > maxMoney ? maxMoney : money);

export const validateMoney = (money, forcePositive = false) =>
  formatMoney(money ? validateMaxMoney(parseFloat(money) || 0) : 0, forcePositive);
